import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "spells", "totalDays", "score" ]

  recalculate(){
    this.scoreTarget.innerHTML = this.spellsTarget.value * this.spellsTarget.value * this.totalDaysTarget.value
  }
}